import React from 'react';
import style from './style/banner_dekton_artik_style.module.scss';
import placeholderImage from './assets/banner-dektop-artik-placeholder.png';
import Translation from '../../global/Translation';
import { FormattedHTMLMessage } from 'react-intl';

const BannerDektonArtik = ({ forceMobile = false }) => {
  const bannerClassName = [
    style['banner-dekton-artik'],
    forceMobile ? style['banner-dekton-artik--mobile'] : '',
  ].filter(Boolean).join(' ');

  return (
    <div className={bannerClassName}>
      <div className={style['banner-dekton-artik__content']}>

        <div className={style['banner-dekton-artik__intro']}>
          <h3 className={style['banner-dekton-artik__title']}>
            <Translation
              id="banner_dekton_artik_title"
              defaultMessage="DEKTON® ARTIK NODES COLLECTION"
            />
          </h3>

          <p className={style['banner-dekton-artik__date']}>
            <Translation
              id="banner_dekton_artik_date"
              defaultMessage="April 27 - May 8"
            />
          </p>
        </div>

        <div className={style['banner-dekton-artik__center']}>
          <p className={style['banner-dekton-artik__subtitle']}>
            <Translation
              id="banner_dekton_artik_subtitle"
              defaultMessage="Early access & Special Launch Pricing on:"
            />
          </p>

          <div className={style['banner-dekton-artik__center-content']}>
            <div className={style['banner-dekton-artik__image-wrapper']}>
              <img
                src={placeholderImage}
                alt="Dekton Artik Nodes"
                className={style['banner-dekton-artik__image']}
              />
            </div>

            <div className={style['banner-dekton-artik__info']}>
              <p className={style['banner-dekton-artik__info-highlight']}>
                <Translation
                  id="banner_dekton_artik_info_highlight"
                  defaultMessage="All colors have QuickCut™ formulation and are jumbo size."
                />
              </p>

              <p className={style['banner-dekton-artik__info-text']}>
                <FormattedHTMLMessage
                  id="banner_dekton_artik_info_text"
                  defaultMessage="Minimum purchase of <b>16 mixed slabs</b> to unlock promotional pricing. Combine with container orders or receive via local statewide availability."
                />
              </p>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default BannerDektonArtik;